import { ToastContainer } from 'react-toastify';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';

// import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

export default function App() {
	return (
		<ThemeProvider>
			<MotionLazyContainer>
				<ToastContainer
					position="top-right"
					autoClose={3000}
					hideProgressBar={false}
					newestOnTop
					closeOnClick
					rtl={false}
					pauseOnFocusLoss={false}
					draggable={false}
				/>
				<ProgressBarStyle />
				<ScrollToTop />
				<Router />
			</MotionLazyContainer>
		</ThemeProvider>
	);
}
